import React, {Component} from 'react'
import propTypes from 'prop-types'
import {prefix} from 'helpers/component'
import {getScrollTop} from 'helpers/ui'
import Popover from '@material-ui/core/Popover'

require('./inlineEditor.scss')
const getClassName = prefix('inlineEditor-')

class BaseEditor extends Component {

  render() {
    const {open, anchor, width, marginLeft, marginTop, padded, children, className, onClose, onEntered} = this.props
    let {height} = this.props

    const classes = ['container']
    if (padded) classes.push('container-padded')
    if (className) classes.push(className)

    let overflowY, popupTop, popupLeft
    let containerMarginLeft = marginLeft, containerMarginTop = marginTop + 20, arrowMarginLeft = 0
    const anchorOrigin = {horizontal: "left", vertical: "bottom"}

    // TODO: Calculate required width and height automatically ?

    // Do we need to place the popup above or below the element?
    if (anchor) {
      const targetPos = anchor.getBoundingClientRect()
      const documentPos = document.body.getBoundingClientRect()

      let requiredHeight = height
      if (padded) requiredHeight += 48

      // Is there enough space below the anchor?
      const spaceBelow = (documentPos.bottom - targetPos.bottom + getScrollTop()) + marginTop
      if (spaceBelow < requiredHeight) {
        let allowedVertSpace = spaceBelow

        // Is there more space above or below the anchor?
        const spaceAbove = targetPos.top - marginTop
        if (spaceAbove > spaceBelow) {
          allowedVertSpace = spaceAbove
          anchorOrigin.vertical = 'top'
          containerMarginTop -= 40
          classes.push('container-above')
        }

        // Take off allocation for arrow and padding
        allowedVertSpace -= 20
        if (padded) allowedVertSpace -= 48

        // In either case, if there isn't enough space, cap the height and scroll
        if (allowedVertSpace < height) {
          height = allowedVertSpace
          overflowY = 'auto'
        }
      }

      const popupHeight = padded ? height + 48 : height
      popupTop = (anchorOrigin.vertical === 'top' ? targetPos.top - popupHeight : targetPos.bottom)
      popupLeft = targetPos.left

      if (width) {
        let requiredWidth = width
        if (padded) requiredWidth += 48

        // If there isn't enough space, move the popover to fit on the screen and move the arrow to accommodate
        const spaceRight = (documentPos.width - targetPos.left) - marginLeft
        if (spaceRight < requiredWidth) {
          arrowMarginLeft += Math.max(0, requiredWidth - spaceRight - 20)
          containerMarginLeft += (spaceRight - requiredWidth)
        }
      }
    }

    return (
      <Popover
        classes={{paper: getClassName(classes)}}
        open={open}
        anchorEl={anchor}
        anchorReference={'none'}
        elevation={3}
        PaperProps={{
          style: anchor
            ? {
              top: popupTop,
              left: popupLeft,
              marginTop: containerMarginTop,
              marginLeft: containerMarginLeft,
            }
            : {},
        }}
        onClose={onClose}
        onEntered={onEntered}
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
        disableEnforceFocus={true}
        disableRestoreFocus={true}
      >
        <div
          className={getClassName('arrow')}
          style={{marginLeft: arrowMarginLeft}}
        />
        <div
          className={getClassName('content')}
          style={{height, overflowY}}
          ref={e => {
            this.content = e
          }}
          tabIndex={1}
        >
          {children}
        </div>
      </Popover>
    )
  }
}

BaseEditor.propTypes = {
  open: propTypes.bool.isRequired,
  anchor: propTypes.object,
  height: propTypes.number.isRequired,
  width: propTypes.number,
  children: propTypes.any,
  padded: propTypes.bool,
  className: propTypes.string,
  marginLeft: propTypes.number,
  marginTop: propTypes.number,
  onClose: propTypes.func.isRequired,
  onFocus: propTypes.func,
  onEntered: propTypes.func,
}

BaseEditor.defaultProps = {
  padded: true,
  marginLeft: 0,
  marginTop: 0,
}

export default BaseEditor
